"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../Button/index.scss");
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
const SaveDraftButton = (props) => props.render ? (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary-small', className: 'save-for-later', disabled: props.disabled, onClick: props.onClick }, "Save as draft")) : (react_1.default.createElement("div", null));
exports.default = SaveDraftButton;
